/*
* Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/
import { Injectable } from '@angular/core';
import { ApiService } from '../shared/api.service';
import { Observable} from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RawDataDiscoveryService {

  private api_url: string;

  constructor(private apiService: ApiService) {
    this.api_url = environment.cdt.api_url;
  }

  triggerAssetDiscovery(systemGUID: string): Observable<any> {
    const reqObj = JSON.stringify({
      systemGuid: systemGUID
    });
    return this.apiService.post('sites/remoteDiscovery', this.api_url, reqObj);
  }
}
